import { Skeleton } from '@repo/ui/src/components/ui/skeleton';

/**
 * The loading block every detail page shows (design 13 §States): the shape of
 * the page, not the word "…". Two identity lines, the stat row where the page
 * has one, then N content rows — so nothing jumps when the data lands.
 *
 * Sized to the M 896 container the three detail pages share.
 */
export function DetailSkeleton({ stats = false, rows = 3 }: { stats?: boolean; rows?: number }) {
  return (
    <div className="mx-auto w-full max-w-4xl p-8" aria-busy="true">
      <Skeleton className="mb-5 h-3.5 w-20" />
      <Skeleton className="h-8 w-64" />
      <div className="mt-[25.6px] space-y-2">
        <Skeleton className="h-4 w-72" />
        <Skeleton className="h-3.5 w-56" />
      </div>
      {stats && (
        <div className="mt-[19.2px] grid grid-cols-2 gap-2 md:grid-cols-4 md:gap-[9.6px]">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className={i < 2 ? 'hidden h-[68px] md:block' : 'h-[68px]'} />
          ))}
        </div>
      )}
      <Skeleton className="mt-[25.6px] h-5 w-40" />
      <div className="mt-[9.6px] space-y-[9.6px]">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} className="h-24 w-full" />
        ))}
      </div>
    </div>
  );
}
